import en from './en';
import ja from './ja';
import ko from './ko';
import zhCN from './zh-CN';
import zhTW from './zh-TW';

module.exports = {
	en,
	ja,
	ko,
	'zh-CN': zhCN,
	'zh-TW': zhTW,
};



// WEBPACK FOOTER //
// ./src/util/resources/index.js